<template>
  <div class="box box--region">
    <div class="box-bg">
      <img :src="image" @error="changeMap" />
    </div>
    <div class="box-inner">
      <router-link :to="`/${$route.params.companySlug}/global-delivery-network/${slugify(box.value)}`" class="box-title" :href="box.link"><span>{{box.value}}</span></router-link>
      <a class="box-link2">View details</a>
    </div>
  </div>
</template>

<script>
import {slugify} from "@/helpers/slugify";

export default {
  name: "GDNRegionBox",
  props: ['box'],
  data() {
    return {
      image: `/web/map-${this.box.code}.svg`
    }
  },
  methods: {
    slugify: slugify,
    changeMap() {
      this.image = 'map-default.svg'
    }
  }
}
</script>
